import React from 'react';
//@ts-ignore
import {GeneralAssetUrl,ParseCategoryIds} from './../../themes/kent/utilities/constants';
//@ts-ignore
import {GetLocalizedText,GetLocalizedPrice,ReturnProductDetailLink, GenerateProductAssetUrl} from './../../themes/kent/utilities/functions';
//@ts-ignore
import {GetProductBySlug} from './../../themes/kent/utilities/dataFunctions';
//@ts-ignore
import {FindFromParse} from './../../themes/kent/utilities/parse';


/**
 *
 * Scroll product tile component
 * @extends {React.Component}
 */
interface IProps {
  product?: any;
  slug?:any;
  year?:any;
}

interface IState {
  calloutImage?:string;
  productImage?:string;
  link?:string;
  title?:string;
  price?:string;
  sizes?:any;
  callout?:string;
  product?:any;
  tagline?:string;
  paddingOverrideStyle?:any;
  productNumber?:any;
  callouts?:any;
}

class ProductTile extends React.Component<IProps>{

  public state: IState;

  constructor(props: IProps) {
    super(props);
    this.state ={};
  }
  componentDidMount = async() =>{
    let product:any = this.props.product;
    let prodAssetUrl:string = GenerateProductAssetUrl(this.props.year);
    if(this.props.slug){
      product = await GetProductBySlug(this.props.slug);
    }
    let calloutImage:any = null;
    let productImage:string = prodAssetUrl+product.attributes.slug+"1_500.png";
    let paddingOverrideStyle:any = {display:"block"};
    let thumbOverrideArray:any = [ParseCategoryIds.wakeboards,ParseCategoryIds.wakesurfers];
    let paddingOverrideArray:any = [ParseCategoryIds.wakeboardRopesAndHandles]
    if(thumbOverrideArray.indexOf(product.attributes.category) != -1 && product.attributes.subcategory != "EYPAnD1L4c" ){
      productImage = prodAssetUrl+product.attributes.slug+"-thumb.png";
    }
    if(product.attributes.slug.indexOf('waterskis-') != -1){
      productImage = prodAssetUrl+product.attributes.slug+"-thumb.png";
    }
    if(paddingOverrideArray.indexOf(product.attributes.category) == -1 ){
      paddingOverrideStyle = {paddingTop:'0px', paddingBottom:'0px'};
    }
    let link:string = await ReturnProductDetailLink(product);

    let title:Promise<string> = await GetLocalizedText(product.attributes.content,'title');
    let tagline:Promise<string> = await GetLocalizedText(product.attributes.content,'tagline');
    let price:Promise<string> = await GetLocalizedPrice(product.attributes.content,'price');
    let sizes:any = product.attributes.sizes;
    let productNumber:any;
    if(product.attributes.brand == "fatsac" || product.attributes.brand == "barefootinternational"){
      sizes = null;
      productNumber = product.attributes.productNumber;
    }
    if(product.attributes.isNew){
      calloutImage = GeneralAssetUrl+"callout-new.png";
    }
    let callout:string = product.attributes.isNew;
    if(product.attributes.isEco){
      calloutImage = GeneralAssetUrl+"callout-eco.png";
    }
    if(product.attributes.isSoftshell){
      calloutImage = GeneralAssetUrl+"callout-softshell.png";
    }
    this.setState({
      paddingOverrideStyle:paddingOverrideStyle,
      calloutImage:calloutImage,
      productImage:productImage,
      link:link,
      title:title,
      tagline:tagline,
      price:price,
      sizes:sizes,
      callout:callout,
      product:product,
      productNumber:productNumber
    },()=>{
      if(product.attributes.productCallouts){
        this.setupCallouts(product)
      }
    })
  }
  setupCallouts = async (product:any) =>{
    let results:any = await FindFromParse("ProductCallouts",[{'method':'limit','value':5000}]);
    let callouts:any = results.filter((callout:any) => product.attributes.productCallouts.indexOf(callout.id) != -1);
    this.setState({
      callouts:callouts
    })
  }
  public render():JSX.Element {
    if(!this.state.product) return <span />;
    return(
      <a href={this.state.link}  style={{display:'initial'}}>
        <div className="product-tile primary-background">
          <div className="product-tile-callout-column">
            {this.state.calloutImage && <img className="product-tile-callout" src={this.state.calloutImage} />}
            {this.state.callouts && this.state.callouts.map((callout:any) =>{
              let image:any = null;
              if(callout.attributes.image){
                image = callout.attributes.image.url();
              }
              return(<img className="product-tile-callout" src={image} />)
            })}
          </div>
          <div className="product-tile-image-wrapper" style={this.state.paddingOverrideStyle}>
            <img className="product-tile-image" src={this.state.productImage} />
          </div>
          <div className="product-tile-text-wrapper">
            <div className="product-tile-left-column">
              <h5 className="product-tile-title text-color-primary">{this.state.title}</h5>
            </div>
            <div className="product-tile-right-column">
              <h5 className="product-tile-price text-color-primary">{this.state.price}</h5>
            </div>
            <div className="product-tile-full">
              <p className="product-tile-tagline text-color-secondary">{this.state.tagline}</p>
              {this.state.sizes &&
                <div className="size-wrapper">
                  {this.state.sizes.map((data:string) =>{
                    return(<div className="label"><span className="text-color-secondary">{data}</span></div>)
                  })}
                </div>
              }
              {this.state.productNumber &&
                <div className="size-wrapper">
                  <div className="label"><span className="text-color-secondary">{this.state.productNumber}</span></div>
                </div>
              }
            </div>
          </div>
        </div>
      </a>
    )
  }
}

 export default ProductTile;
